import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import styles from './styles.scss';
import messages from './messages';

const SuspendWireTransferForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.suspendWire} />}
    submitLabel={<FormattedMessage {...messages.suspendWire} />}
  >
    <ControlLabel htmlFor="comment" className={styles.commentLabel}>
      <FormattedMessage {...messages.comment} />
      <Field
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>
  </ModalForm>
);


SuspendWireTransferForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'SuspendWireTransfer', enableReinitialize: true })(SuspendWireTransferForm);



// WEBPACK FOOTER //
// ./src/components/SuspendWireTransferForm/index.js